import { createWidgetConfiguration, WidgetConfiguration, } from "@sg-widgets/shared-core";
/**
 * Initialize and performs sanity checks for your widget.
 * @param widget Your widget contructor or its tag name.
 */
export function initializeWidgetConfiguration(widget, options) {
    if (options === void 0) { options = {}; }
    var widgetTag = widget.is;
    var privateCtor = widget;
    if (privateCtor.__widgetConfiguration__) {
        privateCtor.__widgetConfiguration__.log("Widget configuration already initialized...try to prevent this");
    }
    privateCtor.__widgetConfiguration__ = createWidgetConfiguration(widgetTag, options);
}
export function extractWidgetConfiguration(constructor) {
    return constructor.__widgetConfiguration__;
}
/**
 * Returns a test configuration suitable for use in your tests/specs.
 *
 * **WARNING**: Use only in your test code !!
 */
export function testWidgetConfiguration(options) {
    if (options === void 0) { options = {}; }
    return new WidgetConfiguration("TEST_WIDGET_CONFIGURATION", window.SGWTWidgetConfiguration, options);
}
/**
 * TESTS-ONLY: resetting the Widget configuration to the default.
 * @deprecated
 */
export function resetWidgetConfiguration(widget) {
    window.SGWTWidgetConfiguration.__dangerousResetSGWTWidgetConfiguration__();
    if (widget) {
        var privateCtor = widget;
        if (privateCtor.__widgetConfiguration__) {
            delete privateCtor.__widgetConfiguration__;
        }
    }
}
//# sourceMappingURL=index.js.map